module.exports = __webpack_public_path__ + "c63175c27485f2acb8a70697fd1711fe.pdf";